import React, { useState } from "react";

const ActivityApproveRejectConfirmationModal = ({
  handleClose,
  handleConfirm,
  roleId,
  isLoading,
}) => {
  const [approvalStatus, setApprovalStatus] = useState("");
  const [remarks, setRemarks] = useState("");

  const handleApprovalChange = (event) => {
    setApprovalStatus(event.target.value);
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">
                {roleId === "25"
                  ? "COO"
                  : roleId === "19"
                  ? "Accounts"
                  : "Activity"}{" "}
                Approval
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body fs-9">
              <div className="mb-3">
                <label className="form-label">Approval Status</label>
                <select
                  className="form-select"
                  value={approvalStatus}
                  onChange={handleApprovalChange}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  <option value="Approved">Approve</option>
                  <option value="PendingApproval">
                    Futher Information Required
                  </option>
                  <option value="Rejected">Reject</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Remarks</label>
                <textarea
                  className="form-control"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => handleConfirm(approvalStatus, remarks)}
                disabled={isLoading}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ActivityApproveRejectConfirmationModal;
